var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('crud',_vm._b({},'crud',_vm.$attrs,false)),_c('import-edocuments-report-dialog',{attrs:{"report":_vm.$route.query.import_report},on:{"close":_vm.closeReport}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }